import { makeDeleteRequest } from 'owa-ows-gateway';
import { SAVE_CALENDAR_VIEW_API_BASE_URL } from '../utils/constants';

export async function deleteSavedCalendarViewService(id: string): Promise<Response> {
    try {
        const response = await makeDeleteRequest(
            `${SAVE_CALENDAR_VIEW_API_BASE_URL}/${id}`,
            null /* requestObject */,
            undefined /* correlationId */,
            true /* returnFullResponse */,
            undefined /* customHeaders */,
            undefined /* throwServiceError */,
            undefined /* includeCredentials */
        );
        if (response.ok) {
            return response;
        }
        return null;
    } catch {
        return null;
    }
}
